// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"c33710bd","278":"c33710bd","841":"c33710bd","885":"c33710bd"}[chunkId] + ".chunk.css";
};